// extracted by mini-css-extract-plugin
export default {"skipLink":"RouteRAF_skipLink__h1dL4"};